import {addClass, find, findAll, removeClass, listener} from "../../../../../modules/vegas/js/util";

const VGListRollup = {
	hide: function ($list) {
		let $list_item = findAll('li', $list),
			cnt = Number($list.dataset.cnt) || 5,
			i = 1;

		for (const $item of $list_item) {
			if (!$item.classList.contains('show-more')) {
				if (i > cnt) {
					addClass($item, 'd-none')
				}

				i++;
			}
		}

		if (i > cnt) {
			this.more($list, 'Показать еще');
		}
	},

	show: function ($list) {
		let $liHidden = [...findAll('.d-none', $list)];
		console.log($liHidden)
		if ($liHidden.length) {
			$liHidden.forEach(($li) => removeClass($li, 'd-none'))
		}

		this.more($list, 'Свернуть');
	},

	more: function (list, text) {
		let $showMore = find('[data-vg-toggle="show-links"]', list);

		if (!$showMore) {
			let $li = document.createElement('li');
			addClass($li, 'list-item show-more');
			$li.innerHTML = '<a href="#" data-vg-toggle="show-links">'+ text +'</a>';

			list.append($li);
		} else {
			$showMore.innerText = text;
		}
	}
}

if (window.screen.width < 450) {
	let $listRollup = [...findAll('.list-links')];

	if ($listRollup.length) {
		$listRollup.forEach(($list) => VGListRollup.hide($list));

		listener('click', '[data-vg-toggle="show-links"]', function (el, e) {
			e.preventDefault();

			let $list = el.closest('.list-links');

			if ($list.classList.contains('show')) {
				VGListRollup.hide($list);
				removeClass($list, 'show');
			} else {
				VGListRollup.show($list);
				addClass($list, 'show');
			}
		});
	}
}
